export const getBetNo = (opportunityIndex: number, offset: number): number =>
  opportunityIndex + offset;
